import { render, staticRenderFns } from "./furni.html?vue&type=template&id=d01e2496&"
import script from "./furni.js?vue&type=script&lang=js&"
export * from "./furni.js?vue&type=script&lang=js&"
import style0 from "./furni.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports